import React from 'react';

export enum ModelTypes {
  VISION,
  NO_VISION,
}

export interface IModel {
  id: string;
  name: string;
  description: string;
  icon: React.ReactNode;
  modelType: ModelTypes;
  isThinkingModel: boolean;
  isDefaultModel: boolean;
  order: number;
}

interface SupportedExtensions {
  image: string[];
  document: string[];
}

export const modelSupportedExtensionsMap: Record<ModelTypes, SupportedExtensions> = {
  [ModelTypes.VISION]: {
    image: ['.jpg', '.jpeg', '.png', '.heic'],
    document: ['.pdf', '.csv'],
  },
  [ModelTypes.NO_VISION]: {
    image: [],
    document: ['.pdf', '.csv'],
  },
};

export const allSupportedImageExtensions = [
  ...modelSupportedExtensionsMap[ModelTypes.VISION].image,
  ...modelSupportedExtensionsMap[ModelTypes.NO_VISION].image,
];
